import type { CSSProperties } from 'react'

export interface FieldProps {
  label: string
  value: string
  onChange: (v: string) => void
  type?: 'text' | 'date' | 'decimal'
  hint?: string
  required?: boolean
  multiline?: boolean
  select?: string[]
  selectOptions?: { value: string; label: string }[]
}

const inputStyle: CSSProperties = {
  width: '100%',
  maxWidth: 320,
  padding: 'var(--space-3)',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--color-surface)',
  color: 'var(--color-text)',
  fontSize: 'var(--font-size-sm)',
  fontFamily: 'inherit',
}

const textareaStyle: CSSProperties = {
  ...inputStyle,
  maxWidth: 'none',
}

const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 'var(--font-size-xs)',
  fontWeight: 600,
  color: 'var(--color-text-muted)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: 'var(--space-1)',
}

const hintStyle: CSSProperties = {
  fontSize: 'var(--font-size-xs)',
  color: 'var(--color-text-faint)',
  marginTop: 'var(--space-1)',
}

export function Field({
  label, value, onChange, type = 'text', hint, required, multiline, select, selectOptions,
}: FieldProps) {
  return (
    <div style={{ marginBottom: 'var(--space-3)' }}>
      <label style={labelStyle}>
        {label} {required && <span style={{ color: 'var(--color-danger-text)' }}>*</span>}
      </label>
      {selectOptions ? (
        <select value={value} onChange={(e) => onChange(e.target.value)} style={inputStyle}>
          {selectOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      ) : select ? (
        <select value={value} onChange={(e) => onChange(e.target.value)} style={inputStyle}>
          {select.map((opt) => (
            <option key={opt} value={opt}>{opt || '—'}</option>
          ))}
        </select>
      ) : multiline ? (
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={2} style={textareaStyle} />
      ) : (
        <input
          type={type === 'date' ? 'date' : 'text'}
          inputMode={type === 'decimal' ? 'decimal' : undefined}
          required={required}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={inputStyle}
        />
      )}
      {hint && <p style={hintStyle}>{hint}</p>}
    </div>
  )
}
